module.exports = "<button nbButton size=\"medium\" status=\"danger\" (click)='verArchivo()'><i class=\"fas fa-search-plus\"></i></button> "